/**
 * External dependencies
 */
import { useMemo } from 'react';

/**
 * Internal dependencies
 */
import Env from '@naruto/bgdcms/src/env';

export type useEnv = typeof Env;

/**
 * 描述 : 取得環境變數
 */

export default function useEnv(): useEnv {
  /* Main */
  return useMemo(() => Env, []);
}
